<template>
	<div class="agileits_w3layouts-footer">
		<p>© 2020 abhiram.info. All rights reserved.</p>
	</div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
